define('appkit/changes.helper',[
  'underscore',
  'backbone'
], function(_, Backbone) {
  var UNSAVED_CHANGES = 'changes';

  function isNestedModelEqual(a, b) {
    return a.id == b.id;
  };

  function isNestedCollectionEqual(a, b) {
    if (a.length != b.length) { return false; }

    for (var i = 0; i < a.length; i++) {
      if (!isNestedModelEqual(a.at(i), b.at(i))) {
        return false;
      }
    };
    return true;
  };

  function isModelEqual(a, b) {
    if (a === b) { return true; }
    if (!(a instanceof Backbone.Model) || !(b instanceof Backbone.Model)) { return false; }
    var aKeys       = a.keys(),
        bKeys       = b.keys(),
        valueA      = null,
        valueB      = null,
        childModels = _.extend({}, a.childModels, b.childModels),
        allKeys     = null;

    if (aKeys.length !== bKeys.length) { return false; }

    allKeys = _.union(aKeys, bKeys);

    for (var i = 0, len = allKeys.length, key; i < len; i++) {
      key = allKeys[i];
      valueA = a.get(key);
      valueB = b.get(key);
      // we don't care about comparing nested child models
      if (valueA !== valueB) {
        if (childModels[key]) {

          if (!valueA || !valueB) {
            // if either value is falsey 
            // then just return false
            return false;
          }
          if ((valueA instanceof Backbone.Model) && (valueB instanceof Backbone.Model)) {
            if (isNestedModelEqual(valueA, valueB)) {
              continue;
            }
          } else if ((valueA instanceof Backbone.Collection) && (valueB instanceof Backbone.Collection)) {
            if (isNestedCollectionEqual(valueA, valueB)) {
              continue;
            }
          }

          // if we don't know what type they are
          // or the previous tests did not pass
          // then just return false
          return false;
        }
        // they are not equal and
        // they are not childModels
        // so just return false
        return false;
      }
    }
    return true;
  };

  var ChangesHelper = Backbone.Model.extend({

    initialize: function() {
      this.unsavedViewCount = 0;
      this.set(UNSAVED_CHANGES, false);
    },

    add: function(model) {
      var unsaved  = false,
          original = model.clone();


      function calculateChange() {
        var hasChanges = !this.isModelEqual(original, model);
        if (hasChanges && unsaved == false) {
          this.unsavedViewCount++;
        } else if (!hasChanges && unsaved == true) {
          this.unsavedViewCount = Math.max(0, this.unsavedViewCount-1);
        }
        unsaved = hasChanges;
        this._refreshState();
      };

      function reset() {
        original = model.clone();
        calculateChange.call(this);
      };

      function clear() {
        original = null;
        calculateChange.call(this);
      };

      this
          .listenTo(model, 'change', calculateChange)
          .listenTo(this, 'reset', reset)
          .listenTo(model, 'invalid', clear)
          .listenTo(model, 'sync', reset);

      return this;
    },

    isModelEqual: function(a, b) {
      return isModelEqual(a, b);
    },

    remove: function(model) {
      this.stopListening(model);
      return this;
    },

    reset: function() {
      this.trigger('reset');
      return this;
    },

    _refreshState: function() {
      if (this.unsavedViewCount > 0) {
        this.set(UNSAVED_CHANGES, true);
      } else {
        this.set(UNSAVED_CHANGES, false);
      }
    }
  });

  ChangesHelper.UNSAVED_CHANGES = UNSAVED_CHANGES;
  ChangesHelper.isModelEqual = isModelEqual;

  return ChangesHelper;
});
